import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import {
  HttpError,
  type IHttpClient,
} from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ExpenseFormReimbursementCustomization } from '@webapp/modules/expense/entities/enums'
import { type IReimbursementSettingsRepository } from '../../../business-logic/interfaces/IReimbursementSettingsRepository'
import { type ReimbursementSettingsApiModel } from '../../api-models/ReimbursementSettingsApiModel'

interface Dependency {
  httpClient: IHttpClient
}

export class ReimbursementSettingsRepository implements IReimbursementSettingsRepository {
  constructor(private readonly deps: Dependency) {}

  async get(): Promise<Nullable<ExpenseFormReimbursementCustomization>> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<ReimbursementSettingsApiModel>
      >(`/api/v3/kvstore/system-preferences/expense-reimbursement/`)

      return res.data.data.value as ExpenseFormReimbursementCustomization
    } catch (err) {
      // 400/404 from the kvstore endpoint signals "no preference saved yet" —
      // return null so callers can apply their own default instead of erroring.
      if (
        err instanceof HttpError &&
        (err.status === 400 || err.status === 404)
      ) {
        return null
      }
      throwRepoErrorFromApiV3Error(err)
    }
  }

  async update(value: ExpenseFormReimbursementCustomization): Promise<void> {
    try {
      await this.deps.httpClient.post<
        ApiResponse<ReimbursementSettingsApiModel>,
        ReimbursementSettingsApiModel
      >(`/api/v3/kvstore/system-preferences/`, {
        key: 'expense-reimbursement',
        value,
      })
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
